export default class DiagnosisCode {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "";
  }

  getDiagnosisCodeList(search, pageNo, pageSize) {
    if (pageNo && pageSize) {
      return this.client.get(`/diagnosiscodes`, {
        params: { search, pageNo, pageSize },
      });
    }
    return this.client.get(`/diagnosiscodes`, { params: { search } });
  }
  getDiagnosisCodeRangeList(from, to) {
    return this.client.get(`/diagnosiscoderange`, { params: { from, to } });
  }
  getDiagnosisCodeDescriptions(codeList) {
    return this.client.post(`/getdiagnosisdescriptions`, codeList);
  }

  getDiagnosisCodeRange(startCode, endCode) {
    return this.client.get(`/diagnosis-codes`, {
      params: { startCode, endCode },
    });
  }

  getCodeGroupDiagnosisCodeList(healthPlanKey, status) {
    return this.client.get(`/code-group/diagnosis`, {
      params: { healthPlanKey, status },
    });
  }
}
